import { configureStore, combineReducers } from "@reduxjs/toolkit";

import authReducer from "./auth";
import paramsSlice from "./params";

export const store = configureStore({
  reducer: combineReducers({
    auth: authReducer,
    params: paramsSlice,
  }),
});
